export default {"src":"/_next/static/media/icon-time.857a1df8.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};